import PopupResult from '~/src/components/Popups/PopupResult';
import { flushSubmitResult } from '~/src/packages/bp42/actions';
import selectDataForPopup from '~/src/packages/bp42/selectors/selectDataForPopup';

import { useCtxDispatch, useCtxSelector, useIncomingCallbacks } from '../hooks';

import * as ST from './../styled';

const ResultPopup = (): JSX.Element | null => {
    const callbacks = useIncomingCallbacks();
    const dispatch = useCtxDispatch();

    const {
        needToShowResponseResult,
        result: {
            ok,
            message,
            status,
        },
    } = useCtxSelector(selectDataForPopup);

    const handleClosePopup = () => {
        callbacks.onCloseResultPopup();
        dispatch(flushSubmitResult());
    };

    if (!needToShowResponseResult) {
        return null;
    }

    return <ST.LazyCallBack>
        <PopupResult
            isOpen={ok !== undefined}
            onClose={handleClosePopup}
            title={ok ? 'Заявка на подключение отправлена' : 'Произошла ошибка'}
            text={ok ? 'Мы свяжемся с вами в ближайшее время' : message}
            type={status}
            data-test='lazy-callback-popup-result'
        />
    </ST.LazyCallBack>;
};

export default ResultPopup;
